
import { Vue, Options } from 'vue-class-component';

import { dia } from '@/service/dia';
import Nomination from '@/service/nomination';

import MaterialIconButton from '@/components/material/IconButton.vue';
import MaterialTopAppBar from '@/components/material/TopAppBar.vue';
import MaterialTopAppBarAdjust from '@/components/material/TopAppBarAdjust.vue';
import ActionsBlock from '@/components/details/Actions.vue';
import InfoBlock from '@/components/details/Info.vue';
import NominationEditor, { EditData } from "@/components/details/Editor.vue";

import locales from './NominationDetails.locales.json';
import { toRaw } from '@vue/reactivity';

@Options({
    components: {
        MaterialTopAppBar, MaterialTopAppBarAdjust,
        MaterialIconButton,
        ActionsBlock, InfoBlock,
        NominationEditor
    },
    i18n: {
        messages: locales
    }
})
export default class NominationDetails extends Vue {

    nomination: Nomination | null = null;

    editing: boolean = false;
    editData = new EditData();

    get available(): boolean {
        return this.nomination !== null;
    }

    get title(): string {
        return this.nomination?.title ?? this.$t('notFound');
    }

    created() {
        this.load();
    }

    edit() {
        if (!this.nomination) return;
        this.editData.from(this.nomination);
        this.editing = true;
    }

    cancel() {
        this.editing = false;
    }

    save() {
        if (!this.nomination) return;
        this.editData.save(this.nomination);
        dia.save(toRaw(this.nomination.raw));
        this.editing = false;
    }

    private async load() {
        const id = this.$route.query.id;
        if (!id || typeof(id) !== 'string') return;
        const raw = await dia.get(id);
        if (!raw) return;
        this.nomination = Nomination.from(raw);
    }
}
